import { render, staticRenderFns } from "./showGoods.vue?vue&type=template&id=b7c89f64&"
import script from "./showGoods.vue?vue&type=script&lang=js&"
export * from "./showGoods.vue?vue&type=script&lang=js&"
import style0 from "./showGoods.vue?vue&type=style&index=0&id=b7c89f64&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.10.2_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17._qkvgvrmvpkafkn37suro37nope/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_gys_admin_online_docker/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7c89f64')) {
      api.createRecord('b7c89f64', component.options)
    } else {
      api.reload('b7c89f64', component.options)
    }
    module.hot.accept("./showGoods.vue?vue&type=template&id=b7c89f64&", function () {
      api.rerender('b7c89f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/nb/goods/goods/components/goodsBase/components/showGoods.vue"
export default component.exports